import { jsx as r } from "react/jsx-runtime";
import { useRef as c, useState as m, useEffect as _ } from "react";
import { c as i } from "../clsx-OuTLNxxd.js";
import { T as u, b as C, h as p, g as B, a as y, d as f, c as h, e as k } from "../Table-C-8YMfYz.js";
import '../GridTable.css';const N = "_gridTableWrapper_1e5ek_274", R = "_gridTable_1e5ek_274", W = "_gridTableRow_1e5ek_284", G = "_gridTableColumn_1e5ek_288", M = "_gridTableCaption_1e5ek_291", w = "_gridTableHeader_1e5ek_292", F = "_gridTableBody_1e5ek_293", H = "_gridTableFooter_1e5ek_294", x = "_gridTableCell_1e5ek_298", E = "_fullWidthMobile_1e5ek_301", j = "_hasMultipleTableBodies_1e5ek_310", v = "_mainColumn_1e5ek_345", o = {
  gridTableWrapper: N,
  gridTable: R,
  gridTableRow: W,
  gridTableColumn: G,
  gridTableCaption: M,
  gridTableHeader: w,
  gridTableBody: F,
  gridTableFooter: H,
  gridTableCell: x,
  fullWidthMobile: E,
  hasMultipleTableBodies: j,
  mainColumn: v
}, d = ({ children: e, className: l, label: a, mobileColumns: s, ...n }) => {
  const t = c(null), [b, T] = m(1);
  return _(() => {
    if (t.current) {
      const g = t.current.getElementsByClassName(o.gridTableBody);
      T(g.length);
    }
  }, []), /* @__PURE__ */ r(
    "div",
    {
      "aria-label": a,
      className: o.gridTableWrapper,
      "data-cxy-name": "grid-table",
      style: {
        "--gridWidth": b + 1,
        ...b === 1 ? { gridTemplateColumns: "auto" } : {},
        "--mobileColumns": s
      },
      children: /* @__PURE__ */ r(
        u,
        {
          className: i(o.gridTable, l, {
            [o.hasMultipleTableBodies]: b > 1
          }),
          ref: t,
          ...n,
          children: e
        }
      )
    }
  );
}, O = ({ children: e, className: l, ...a }) => /* @__PURE__ */ r(p, { className: i(o.gridTableRow, l), ...a, children: e }), S = ({ children: e, className: l, isMain: a, ...s }) => /* @__PURE__ */ r(
  f,
  {
    className: i(
      o.gridTableColumn,
      {
        [o.mainColumn]: a
      },
      l
    ),
    ...s,
    children: e
  }
), q = ({
  children: e,
  className: l,
  isFullWidthMobile: a,
  isMain: s,
  order: n,
  start: t,
  ...b
}) => /* @__PURE__ */ r(
  h,
  {
    className: i(
      o.gridTableCell,
      {
        [o.fullWidthMobile]: a,
        [o.mainColumn]: s
      },
      l
    ),
    style: { "--cellOrder": n, "--start": t },
    ...b,
    children: e
  }
), z = ({ children: e, className: l, ...a }) => /* @__PURE__ */ r(k, { ...a, className: i(o.gridTableFooter, l), children: e }), A = ({ children: e, className: l, ...a }) => /* @__PURE__ */ r(B, { ...a, className: i(o.gridTableHeader, l), children: e }), D = ({ children: e, className: l, ...a }) => /* @__PURE__ */ r(y, { className: i(o.gridTableBody, l), ...a, children: e }), I = ({ children: e, className: l, ...a }) => /* @__PURE__ */ r(C, { className: i(o.gridTableCaption, l), ...a, children: e });
d.Caption = I;
d.Row = O;
d.Head = A;
d.Body = D;
d.Column = S;
d.Cell = q;
d.Footer = z;
export {
  d as GridTable
};
